import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function Modal({ isOpen, onClose, title, children, maxWidth = 'sm' }) {
  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          background: '#1e293b',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        }
      }}
    >
      <DialogTitle 
        className="flex justify-between items-center"
        sx={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          color: '#e2e8f0'
        }}
      >
        <Box>{title}</Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="ml-auto"
          sx={{
            color: '#94a3b8',
            '&:hover': {
              color: '#e2e8f0'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        dividers
        sx={{
          borderColor: 'rgba(255, 255, 255, 0.1)',
          background: '#1e293b'
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default Modal;
